<template>
  <div>
    <div v-translate:dynamic_string="{ key: `${translationKeyInitial}_formattedBody`, val: lang, html: question.formattedBody }" class="instruction_title text-left para-mrgn-20" v-html="question.formattedBody" />
    <div v-if="!isSingleOption" v-translate:label_select_all_that_apply="lang" class="mt-10 mb-20">SELECT ALL THAT APPLY</div>
    <div v-if="question && question.bodyImages && question.bodyImages[0].imageUrl">
      <img :src="question && question.bodyImages && question.bodyImages[0].imageUrl" class="multiple-choice-img-size" width="100%" />
    </div>
    <div>
      <b-form-group class="mb-5" @click.once="$emit('onClick', question)">
        <component :is="isSingleOption ? 'b-form-radio-group' : 'b-form-checkbox-group'" :checked="isSingleOption ? question.optionsIds[0] : question.optionsIds" :disabled="isFieldDisabled" stacked @change="onAnswerChange($event)">
          <component v-for="option in question.constraints.options" :key="option.id" :id="option.id" :is="isSingleOption ? 'b-form-radio' : 'b-form-checkbox'" :value="option.id" class="light custom_radio">
            <div class="ap-thread-alert-message-preview p-0 col-md-12">
              <span
                v-translate:dynamic_string="{
                  key: widget.getDynamicStringKey(translationKeyInitial, option),
                  val: lang,
                  optionId: option.id,
                  html: getOptionLabel(option)
                }"
                v-html="getOptionLabel(option)"
              ></span>
              <AlertMessage v-if="question.constraints.colorCodeEnabled" :backgroundColor="option.colorCoding && option.colorCoding.color" :message="option.colorCoding && option.colorCoding.warningMessage" />
            </div>
          </component>
          <template v-if="question.isDisplayOtherOptionContentField">
            <div class="light custom_radio other-option-wrap">
              <component :is="isSingleOption ? 'b-form-radio' : 'b-form-checkbox'" :id="question.otherOptionId" :value="question.otherOptionId" class="light custom_radio">
                {{ question.otherOptionContentField }}
              </component>

              <div v-if="question.isDisplayOtherCommentSelectedField && isOtherSelected" class="other-option-comment active-area">
                <textarea :id="'textArea' + question.otherOptionId" :value="question.otherAnswer" :maxlength="commentMaxLength" :placeholder="question.otherCommentSelectedField" class="other-option-comment-area" @keydown="preventInvalidCharacters" @input="onOtherCommentChange"> </textarea>

                <div :class="{ 'max-character-limit': otherCommentLength >= commentMaxLength }" class="other-option-comment-count">{{ otherCommentLength }} / {{ commentMaxLength }} {{ widget.translateToActiveLang("characters", "Characters") }}</div>
              </div>
            </div>
          </template>
        </component>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";
import { Widget } from "@/components/services/participant-service";

export default {
  name: "multiple-choice",
  mixins: [langTranslate],
  props: {
    question: {
      type: Object,
      required: true
    },
    lang: {
      required: true
    },
    isFieldDisabled: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      widget: new Widget(),
      commentMaxLength: 1000,
      isSingleOption: false
    };
  },
  computed: {
    isOtherSelected() {
      return this.question.optionsIds && this.question.optionsIds.includes(this.question.otherOptionId);
    },
    otherCommentLength() {
      return this.question.otherAnswer ? this.question.otherAnswer.length : 0;
    },
    noneOptionId() {
      const noneOption = this.question.constraints.options.find(o => this.getOptionLabel(o).toLowerCase() === "none");
      return noneOption ? noneOption.id : null;
    }
  },
  methods: {
    getOptionLabel(option) {
      return option.displayText ? option.displayText : option.body ? option.body : option.label;
    },
    onOtherCommentChange(event) {
      let value = event.target.value;

      if (typeof value === "string") {
        event.preventDefault();
        value = value.replace(/:/g, "");
        this.question.otherAnswer = value;
      }
    },
    onAnswerChange(event) {
      let optionIds = this.isSingleOption ? [event] : event;
      // none option functionality is commented out as it should be treated in another story
      // if (optionIds && this.noneOptionId && optionIds.includes(this.noneOptionId)) {
      //   optionIds = [this.noneOptionId];
      // }
      this.$set(this.question, "optionsIds", optionIds);
    },
    preventInvalidCharacters(event) {
      if (event.key === ":") {
        event.preventDefault();
      }
    },
    clearAnswer() {
      this.question.optionsIds = [];
      this.question.otherAnswer = "";
    }
  },
  mounted() {
    this.$root.$on("questionSkipped", notifyObj => {
      if (!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped) {
        this.clearAnswer();
      }
    });
  },
  created() {
    this.isSingleOption = this.question.constraints.subType !== "Multi";
    if (!this.question.optionsIds) {
      this.$set(this.question, "optionsIds", []);
    }
    if (!this.question.otherAnswer) {
      this.$set(this.question, "otherAnswer", "");
    }
  }
};
</script>

<style scoped>
.instruction_title p:first-child {
  font-weight: 600 !important;
}

.instruction_title {
  font-weight: normal;
}

.other-option-comment {
  width: 100%;
  margin-top: 15px;
  position: relative;
  border-radius: 5px;
  box-shadow: 0 0 0 1px #4a4a4a;
  padding-bottom: 20px;
}

.other-option-comment-area {
  resize: none;
  width: 100%;
  padding: 10px;
  border: 0;
}

.other-option-comment-count {
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-size: small;
}

.other-option-wrap {
  flex-direction: column;
  align-items: start;
}

.active-area {
  box-shadow: 0 0 0 2px #007bff;
}
</style>
